// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__lo4Od"};